import { LandingContent } from "./types";
import {
  GiHorseHead,
  GiStable,
  GiStopwatch,
  GiNotebook,
  GiChatBubble,
} from "react-icons/gi";
import { FaQuestion } from "react-icons/fa";
import horseImage from "../../assets/images/horse.jpg";

export const horseContent: LandingContent = {
  seo: {
    title: "Lovardák és oktatók online időpontfoglalása | Wobble",
    description:
      "Egyszerű és gyors online időpontfoglaló rendszer lovardáknak, oktatóknak és lovas programok szervezőinek. Próbáld ki a Wobble-t ingyen!",
    ogTitle: "Wobble - Lovardák és oktatók időpontfoglaló rendszere",
    ogDescription:
      "Kezeld egyszerűen a lovarda foglalásokat, vendégeket és kommunikációt egyetlen felületen – spórolj időt és növeld a bevételeidet!",
    keywords: "lovarda, lovas oktatás, időpontfoglalás, online foglalás, wobble",
    image: "../assets/mockup_riding_school.png"
  },
  header: {
    heading: "Időpontfoglaló rendszer lovardáknak és oktatóknak",
    subheading:
      "Kezeld egyszerűen a lovarda foglalásokat, oktatókat és vendégeket – legyen szó egyéni vagy csoportos lovas foglalkozásról.",
    highlightText: "Wobble időpontfoglaló rendszer lovardáknak",
  },
  problems: {
    title: "Ismerős problémák?",
    features: [
      { icon: GiNotebook, text: "Foglalások papíron vagy táblázatokban, ami sok időt vesz igénybe?" },
      { icon: GiChatBubble, text: "Nehezen éred el vendégeidet lemondások vagy változások esetén?" },
      { icon: GiStopwatch, text: "Az időpontok összehangolása és kezelése rengeteg időt elvesz a napi munkából?" },
      { icon: FaQuestion, text: "Ismétlődő kérdések, egyeztetések helyett szeretnéd egyszerűsíteni a folyamatokat?" },
      { icon: GiStable, text: "Nem egyszerű kezelni az egyedi igényeket: oktatók, lovak, helyszínek, felszerelések foglalását?" },
    ],
    summaryText:
      "A Wobble időpontfoglaló rendszerével automatizálhatod az időpontkezelést, így több időd marad a lovakra és vendégeidre.",
    cta: {
      href: "https://app.wobble.hu/signup_page",
      label: "Kipróbálom ingyen",
    },
    imageSrc: horseImage,
    imageAlt: "Lovardai időpontfoglalás",
  },
  whyDigitalize: {
    title: "Miért érdemes digitalizálni?",
    features: [
      { icon: GiHorseHead, text: "A lovasok és vendégek ma már online keresik a helyeket és foglalnak időpontot." },
      { icon: GiStopwatch, text: "Online foglalással a vendégek bármikor, egyszerűen és gyorsan tudnak helyet foglalni." },
      { icon: GiChatBubble, text: "Automatikus értesítések és visszaigazolások csökkentik a telefonos egyeztetések számát." },
      { icon: GiNotebook, text: "Testreszabható foglalási lehetőségek: lovak, oktatók, pályák, felszerelések, időpontok." },
      { icon: GiStable, text: "Egyszerű adminisztráció és áttekinthető nyilvántartás, hogy mindig tudd, ki, mikor érkezik." },
    ],
  },
  whyTheyLove: {
    title: "Hogyan könnyíti meg a munkád a Wobble?",
    imageSrc: "../assets/mockup_riding_school.png",
    imageAlt: "Lovarda időpontfoglalás",
    features: [
      { icon: GiHorseHead, text: "Gyorsan testreszabható foglalási rendszer" },
      { icon: GiStable, text: "Egyedi oktatók, lovak és pályák beállítása, foglalása" },
      { icon: GiStopwatch, text: "Automatikus emlékeztetők és visszaigazolások" },
      { icon: GiChatBubble, text: "Kommunikáció egyszerűen egy helyen, kérdőívvel is" },
      { icon: GiNotebook, text: "Testreszabható egyéni vagy csoportos órák" },
    ],
  },
  trial: {
    title: "🐴 Csatlakozz most",
    title2: "30 nap ingyenes próbaidőszak!",
    subtitle:
      "Próbáld ki a Wobble-t kockázat nélkül, bankkártya megadása nélkül!",
    cta: {
      href: "https://app.wobble.hu/signup_page",
      label: "Regisztrálok most",
    },
  },
};
